/* "Comprar ahora" en las tarjetas de lentes de sol (colecciones y home).
   Agrega el lente al carrito con la opcion de cristales indicada en data-cristales
   de la tarjeta y va directo al checkout.
   Delegacion de eventos: un solo listener para todas las tarjetas de la pagina. */
(function () {
  if (window.__fibraCompraRapida) return;
  window.__fibraCompraRapida = true;

  document.addEventListener('click', async function (evento) {
    const boton = evento.target.closest('[data-compra-rapida]');
    if (!boton || boton.disabled) return;
    evento.preventDefault();

    const textoOriginal = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Procesando…';

    const rutas = window.routes || {};
    const addUrl = rutas.cart_add_url || '/cart/add';
    const cartUrl = rutas.cart_url || '/cart';

    try {
      const respuesta = await fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{
          id: parseInt(boton.dataset.variante, 10),
          quantity: 1,
          properties: boton.dataset.cristales ? { Cristales: boton.dataset.cristales } : {}
        }] })
      });
      if (!respuesta.ok) throw new Error('cart/add ' + respuesta.status);
      // Respeta el prefijo de idioma si la tienda es multi-idioma (/es/cart -> /es/checkout)
      window.location.href = cartUrl.replace(/\/cart$/, '') + '/checkout';
    } catch (error) {
      boton.textContent = 'No se pudo, reintenta';
      setTimeout(function () { boton.textContent = textoOriginal; boton.disabled = false; }, 2500);
    }
  });
})();
